import script from "./BaseSvg.vue?vue&type=script&lang=ts&setup=true"
export * from "./BaseSvg.vue?vue&type=script&lang=ts&setup=true"

import "./BaseSvg.vue?vue&type=style&index=0&id=f9052728&lang=less&scoped=true"

import exportComponent from "../../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.17_vue@3.2.37_webpack@5.69.0_@swc+core@1.12.11_/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f9052728"]])

export default __exports__